import React, {
  ReactElement,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react"
import { Link } from "gatsby"
import SideNav from "../components/sideNav"
import useSiteMetadata from "../hooks/siteMetadata"

function Header(): ReactElement {
  const [isOpen, setIsOpen] = useState(false)
  const { nugetVersion } = useSiteMetadata()

  return (
    <>
      <div className="flex justify-between items-center p-4 border-b">
        <div className="text-2xl text-gray-800 font-semibold flex items-center">
          <div className="md:hidden mr-4 h-5 w-5 flex items-center">
            {!isOpen && (
              <button
                onClick={(e) => setIsOpen(!isOpen)}
                className="text-gray-700 hover:text-gray-500"
              >
                <svg viewBox="0 0 64 64" className="fill-current">
                  <rect y="10" width="80" height="8" rx="4"></rect>
                  <rect y="30" width="80" height="8" rx="4"></rect>
                  <rect y="50" width="80" height="8" rx="4"></rect>
                </svg>
              </button>
            )}
            {isOpen && (
              <button
                onClick={(e) => setIsOpen(!isOpen)}
                className="text-gray-700 hover:text-gray-500"
              >
                <svg
                  className="fill-current stroke-current stroke-2 w-4 h-4"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"></path>
                </svg>
              </button>
            )}
          </div>
          <Link
            to="/"
            className="text-gray-700 hover:no-underline hover:bg-transparent"
          >
            Validatum
          </Link>
        </div>
        <div className="flex items-center">
          <span className="px-2 py-1 bg-teal-100 font-bold text-xs text-teal-600 rounded border border-teal-300">
            v{nugetVersion}
          </span>
          <a
            href="https://github.com/bsheldrick/validatum"
            className="text-gray-700 hover:text-gray-500 hover:bg-transparent ml-4"
          >
            <svg
              className="fill-current h-6 w-6"
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>GitHub</title>
              <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
            </svg>
          </a>
        </div>
      </div>
      {isOpen && <MenuPopup onClose={() => setIsOpen(false)} />}
    </>
  )
}

function MenuPopup({ onClose }: any): ReactElement {
  const menuRef = useRef<HTMLDivElement | null>(null)
  const escapeListener = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose()
      }
    },
    [onClose]
  )
  const clickListener = useCallback(
    (e: MouseEvent) => {
      if (!(menuRef.current! as any).contains(e.target)) {
        onClose?.()
      }
    },
    [onClose]
  )

  useEffect(() => {
    document.addEventListener("click", clickListener)
    document.addEventListener("keyup", escapeListener)
    return () => {
      document.removeEventListener("click", clickListener)
      document.removeEventListener("keyup", escapeListener)
    }
  }, [escapeListener, clickListener])

  return (
    <div
      id="menuPopup"
      ref={menuRef}
      className="absolute left-0 p-4 mb-2 bg-white z-50 border border-gray-200 shadow-md rounded ml-8 -mt-6"
    >
      <SideNav />
    </div>
  )
}

export default Header
